import { Label } from '@cian/ui-kit';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { selectSuburbanRkTitle } from '../../../selectors/countryside';
import { useBackgroundContext } from '../BackgroundProvider';

import styles from './Header.css';

export const CountrysideHeader: FC<React.PropsWithChildren> = ({ children }) => {
  const { imageUrl, defaultImageUrl, isBackgroundShown, label } = useBackgroundContext();
  const suburbanRkTitle = useSelector(selectSuburbanRkTitle);

  const backgroundImg = imageUrl || defaultImageUrl;

  return (
    <div
      className={styles['header']}
      style={isBackgroundShown ? { backgroundImage: `url(${backgroundImg})` } : undefined}
      data-name="HeaderBlock"
    >
      <div className={styles['content']}>
        <div className={styles['inner']}>
          <div className={styles['title']}>{suburbanRkTitle || 'Дома, дачи и участки'}</div>
          {children}
        </div>
        {!suburbanRkTitle && <div className={styles['overlay']} />}
      </div>
      {label && (
        <div className={styles['label']}>
          <Label>{label}</Label>
        </div>
      )}
    </div>
  );
};
